import { PROFILE_ON_EDIT_REVIEW, PROFILE_ON_REMOVE_REVIEW } from '../actions';

import { ProfileReview } from '../../../../types';

type State =
  | {
      editedReview: ProfileReview | null;
      removedReview: string | null;
    }
  | undefined;

type Actions =
  | {
      type: 'PROFILE_ON_EDIT_REVIEW';
      data: ProfileReview;
    }
  | {
      type: 'PROFILE_ON_REMOVE_REVIEW';
      id: string;
    };

export default function profileReducer(state: State, action: Actions) {
  if (!state) {
    return {
      editedReview: null,
      removedReview: null,
    };
  }

  switch (action.type) {
    case PROFILE_ON_EDIT_REVIEW: {
      return {
        ...state,
        editedReview: action.data,
      };
    }

    case PROFILE_ON_REMOVE_REVIEW: {
      return {
        ...state,
        removedReview: action.id,
      };
    }

    default:
      break;
  }

  return state;
}
